var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgmsgperconversationbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3497_3110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1726 18.4185C15.59 18.4185 11.0001 22.23 11.0001 26.9153C11.0001 28.7881 11.7317 30.6915 13.0735 32.1667L11.1787 34.3165C10.9923 34.5283 10.9471 34.8291 11.065 35.0857C11.1823 35.3424 11.4394 35.5072 11.7232 35.5072H21.8958C26.0177 35.5072 31.3452 31.9831 31.3452 26.9153C31.3452 22.23 26.7553 18.4185 21.1726 18.4185ZM16.7854 28.2314C15.988 28.2314 15.3391 27.587 15.3391 26.7954C15.3391 26.0038 15.9881 25.3594 16.7854 25.3594C17.5827 25.3594 18.2317 26.0038 18.2317 26.7954C18.2318 27.587 17.5827 28.2314 16.7854 28.2314ZM21.1726 28.2314C20.3753 28.2314 19.7263 27.587 19.7263 26.7954C19.7263 26.0038 20.3753 25.3594 21.1726 25.3594C21.9699 25.3594 22.6189 26.0038 22.6189 26.7954C22.6189 27.587 21.9699 28.2314 21.1726 28.2314ZM25.5598 28.2314C24.7625 28.2314 24.1135 27.587 24.1135 26.7954C24.1135 26.0038 24.7625 25.3594 25.5598 25.3594C26.3571 25.3594 27.0062 26.0038 27.0062 26.7954C27.0062 27.587 26.3572 28.2314 25.5598 28.2314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5138 25.6103L33.8111 23.6379C35.0265 22.2763 35.6883 20.6159 35.6883 18.898C35.6882 14.543 31.4707 11 26.2871 11C21.5996 11 17.6172 13.9003 16.9141 17.6752C18.222 17.2339 19.6887 16.9831 21.1767 16.9831C27.5095 16.9831 32.7125 21.3748 32.7885 26.796H34.9651C35.5828 26.7961 35.9146 26.0739 35.5138 25.6103Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3497_3110",
    x1: 42.5,
    y1: 3.96703e-7,
    x2: 6.5,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136329,
    stopColor: "#09F6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01889A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgmsgperconversationbot);
export default __webpack_public_path__ + "static/media/avgmsgperconversationbot.6a6bc668256c8f37e0a8c36bb43dfa45.svg";
export { ForwardRef as ReactComponent };